export enum UserRole {
    Admin = 'admin',
    Teacher = 'teacher',
    SuperAdmin = 'super-admin',
    InstructionalDesigner = 'instructional-designer',
    Student = 'student',
    CustomerSupport = 'customer-support'
}

export const systemRoles: UserRole[] = [UserRole.Admin, UserRole.Teacher, UserRole.InstructionalDesigner];

export interface User {
    name: string;
    email?: string;
    ext_user_id?: string;
    roles: UserRole[];
}
